import React, { useState } from 'react';
import Button from '../components/shared/Button';
import { useAuthContext } from '../components/AuthProvider';
import { QueryService } from '../services/QueryService';
import { Toast } from '../components/shared/Toast';
import TextareaWithCounter from '../components/shared/TextareaWithCounter';

const styles = {
	mainHeading: 'text-dark-blue font-bold text-main mt-10',
	section:
		'grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8 bg-white mt-[50px] mb-2.5 md:px-[50px] px-4 border border-lightGrey rounded-lg',
	contactHeading: 'text-25 font-semibold text-dark-blue md:mb-20 mb-6 md:mt-[60px] mt-5',
	label_disabled: 'block text-dark-blue/60 text-base font-medium mb-2',
	label: 'block text-dark-blue text-base font-medium mb-2',
	input:
		'block w-full border border-lightGrey rounded-lg px-3 py-3 text-dark-blue/60 placeholder-gray focus:outline-none',
	messageArea:
		'block w-full border border-lightGrey rounded-lg px-3 py-3 text-dark-blue placeholder-gray focus:outline-none focus:border-purple resize-none'
};

export default function HelpCentrePage() {
	const { user } = useAuthContext();
	const [query, setQuery] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);

	const handleSubmit = async (e) => {
		e.preventDefault();
		const trimmedQuery = query.trim();

		// extra safeguard, button already prevents invalid cases
		if (!trimmedQuery || trimmedQuery.length < 10) {
			Toast.error('Your ticket must be at least 10 characters long.');
			return;
		}

		try {
			setIsSubmitting(true);
			const payload = { query };
			await QueryService.createQuery(payload);
			setQuery('');
			Toast.success('Your support ticket has been submitted successfully. Our team will get back to you shortly.');
		} catch {
			Toast.error('Failed to submit your ticket. Please try again.');
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="">
			<h1 className={styles.mainHeading}>Help Center</h1>

			<div className={styles.section}>
				{/* Left Column: Contact information */}
				<div>
					<h2 className={styles.contactHeading}>Contact Information</h2>
					<div className="mb-4">
						<p className="text-gray text-sm font-medium md:mb-2 mb-0">Email Address</p>
						<p className="text-dark-blue text-20 font-semibold">info@writeformapp.com</p>
					</div>
				</div>

				{/* Right Column: Complete form */}
				<div className='md:my-[60px] my-4'>
					<h2 className="text-2xl font-bold text-dark-blue md:mb-[50px] mb-6">Support Form:</h2>
					<form onSubmit={handleSubmit}>
						<div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
							<div>
								<label htmlFor="first-name" className={styles.label_disabled}>
									First Name
								</label>
								<input
									type="text"
									id="first-name"
									name="first-name"
									className={styles.input}
									value={user.firstName}
									readOnly
								/>
							</div>
							<div>
								<label htmlFor="last-name" className={styles.label_disabled}>
									Last Name
								</label>
								<input
									type="text"
									id="last-name"
									name="last-name"
									className={styles.input}
									value={user.lastName}
									readOnly
								/>
							</div>
						</div>
						<div className="mb-4">
							<label htmlFor="email-address" className={styles.label_disabled}>
								Email Address
							</label>
							<input
								type="email"
								id="email-address"
								name="email-address"
								className={styles.input}
								value={user.email}
								readOnly
							/>
						</div>
						<div className="mb-6">
							<label htmlFor="query" className={styles.label}>
								Message:
							</label>
							<TextareaWithCounter
								id="query"
								value={query}
								onChange={(e) => setQuery(e.target.value)}
								placeholder="Write your support ticket message..."
								minLength={10}
								maxLength={500}
								rows={4}
								className={styles.messageArea}
							/>
						</div>

						<Button
							type="submit"
							className="w-full !py-3 !px-6 !rounded-xl !font-medium !text-base"
							disabled={isSubmitting || query.trim().length < 10}
						>
							{isSubmitting ? 'Submitting…' : 'Submit'}
						</Button>
					</form>
				</div>
			</div>
		</div>
	);
}
